<script>
import TitleImage from "@/components/molecules/title-image";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";

import mesRecettes from "@/assets/images/miam/mes-recettes.svg";
import jaiTeste from "@/assets/images/miam/jai-teste.svg";
import inspirations from "@/assets/images/miam/inspirations.svg";
import HtmlParser from "@/components/organisms/cms-container/html-parser";
import menuCodes from "@/utils/menu-codes";
import { pushProps, usePush } from "@/components/pages/mixins/push-mixin";

export default {
  name: "MiamMenuLayer",
  components: {
    TitleImage,
    List,
    ListItem,
    HtmlParser
  },
  props: {
    ...pushProps()
  },
  setup(props) {
    const { getPushData } = usePush(props.pushZones);

    return {
      getPushData,
      mesRecettes,
      jaiTeste,
      inspirations
    };
  },
  data() {
    return {
      menuCodes
    };
  },
  methods: {}
};
</script>

<template>
  <div class="c-header-menu-layer__miam-container">
    <List class="c-header-menu-layer__categories">
      <ListItem class="c-header-menu-layer__category u-flex-item-fluid">
        <TitleImage
          ref="menuLink"
          :image-path="inspirations"
          class="c-header-menu-layer__title-image"
          slug="/recettes"
          :dimension="200"
        >
          Nos recettes et idées repas
          <p class="c-header-menu-layer__title-image-subtitle">
            Trouvez de nouvelles idées pour varier vos repas
          </p>
        </TitleImage>
      </ListItem>
      <ListItem class="c-header-menu-layer__category u-flex-item-fluid">
        <TitleImage
          ref="menuLink"
          :image-path="jaiTeste"
          class="c-header-menu-layer__title-image"
          slug="/mes-repas"
          :dimension="200"
        >
          Les idées dans mon panier
          <p class="c-header-menu-layer__title-image-subtitle">
            Retrouvez les repas ajoutés pendant vos courses
          </p>
        </TitleImage>
      </ListItem>
      <ListItem class="c-header-menu-layer__category u-flex-item-fluid">
        <TitleImage
          ref="menuLink"
          :image-path="mesRecettes"
          class="c-header-menu-layer__title-image"
          slug="/recettes-favorites"
          :dimension="200"
        >
          Mes idées repas
          <p class="c-header-menu-layer__title-image-subtitle">
            Constituez vote propre cahier de recettes
          </p>
        </TitleImage>
      </ListItem>
    </List>
    <div class="u-flex u-flex-column">
      <HtmlParser
        v-if="getPushData(menuCodes.HEADER_RECETTES,1)"
        :key="pushZones.id"
        class="c-header-menu-layer__miam-zone-merch u-mb-sm u-border-grey-4"
        :content="getPushData(menuCodes.HEADER_RECETTES,1).html_content"
      />
      <HtmlParser
        v-if="getPushData(menuCodes.HEADER_RECETTES,2)"
        :key="pushZones.id"
        class="c-header-menu-layer__miam-zone-merch u-mb-sm u-border-grey-4"
        :content="getPushData(menuCodes.HEADER_RECETTES,2).html_content"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/header-menu-layer.scss";

.c-header-menu-layer__title-image {
  width: auto;
  max-width: initial;

  &:hover {
    p {
      color: color(primary-light);
    }
  }
}
.c-header-menu-layer__title-image-subtitle {
  color: color(text-light);
  font-size: fontSize(12);
  margin-top: spacing(sm);
}
</style>
